export const getDefaultDataCollection = () => {
    try {
        return JSON.parse(process.env.REACT_APP_DEFAULT_DATA_COLLECTION_JSON || "[]");
    } catch (error) {
        return [];
    }
};

export const isDefaultDataCollectionKey = (key) => {
    return getDefaultDataCollection().some(
        field => field.key?.toLowerCase() === key?.toLowerCase()
    );
};
